var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "#51C394",
    rx: 16,
    transform: "matrix(-1 0 0 1 80 0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M40 18c-12.13 0-22 9.87-22 22s9.87 22 22 22 22-9.87 22-22-9.87-22-22-22m0 39.368c-9.577 0-17.368-7.791-17.368-17.368S30.423 22.632 40 22.632 57.368 30.423 57.368 40 49.577 57.368 40 57.368"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M51.81 39.32H43.22a3.8 3.8 0 0 0-1.25-1.25V27.742a1.968 1.968 0 0 0-3.937 0V38.07a3.78 3.78 0 0 0-1.805 3.219A3.78 3.78 0 0 0 40 45.063c1.36 0 2.554-.724 3.218-1.806h8.591a1.968 1.968 0 1 0 0-3.936"
  })));
};
export default SvgClock;